import { createColumn, formatDate, numberFormat } from "../../utils/helpers";
import { TFieldConfig } from "../../types/common";
import { API_CHECK_VEHICLE_STATUS } from "../../utils/apis";

interface UseVehicleLedgerDefaultsProps {
  form: any;
  updateFormValue: (field: string, value: any) => void;
  updateFormValues: (values: any) => void;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  filters: any;
  setFilters: (filters: any) => void;
  setError: (error: any) => void;
}

export const useVehicleLedgerDefaults = ({}: UseVehicleLedgerDefaultsProps) => {
  const searchFields: TFieldConfig[] = [
    {
      field_name: "number_plate",
      label: "Vehicle Plate",
      type: "text",
      props: {
        placeholder: "Enter vehicle plate number",
        required: true,
      },
    },
  ];

  const tableColumns = () => [
    createColumn("invoice_number", false, "Invoice Number"),
    createColumn("district", false, "District"),
    createColumn("parking_yard", false, "Parking Yard"),
    createColumn("date_time", false, "Date"),
    createColumn("days_past_due", false, "Days Overdue"),
    createColumn("outstanding_balance", false, "Outstanding Balance"),
    createColumn("number_of_times_defaulted", false, "Times Defaulted"),
  ];

  const tableData = (data: any) => {
    if (!data) return [];

    const timesDefaulted = data?.number_of_times_defaulted || 0;

    return data?.details?.map((item: any) => ({
      ...item,
      date_time: item.date_time
        ? formatDate(item.date_time, "DD/MM/YYYY")
        : "N/A",
      outstanding_balance: item.outstanding_balance
        ? numberFormat(item.outstanding_balance)
        : "N/A",
      days_past_due: item.days_past_due || "0",
      number_of_times_defaulted: timesDefaulted,
    }));
  };

  const api = API_CHECK_VEHICLE_STATUS;
  const tableTitle = "Defaulted Vehicles";
  const initialFilters = {};
  // const exportData = {
  //   api: "/api/vehicle-ledger/defaults/export/",
  //   fileName: "vehicle_defaults.xlsx",
  // };

  return {
    searchFields,
    tableColumns,
    tableData,
    tableTitle,
    api,
    initialFilters,
    // exportData,
  };
};
